module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "15px",
      "height": "15px",
      "viewBox": "0 0 15 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("3F00B732-1154-411E-9214-252B68E713A1")]), _vm._v(" "), _c('desc', [_vm._v("Created with sketchtool.")]), _vm._v(" "), _c('g', {
    staticClass: "defaultOpactiy",
    class: {
      'activeOpacity': _vm.editModeActive
    },
    attrs: {
      "id": "Linear",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "opacity": "0.499883743"
    }
  }, [_c('g', {
    staticClass: "default",
    class: {
      'yellow-pencil': _vm.editModeActive
    },
    attrs: {
      "id": "1-Linear-Workbench-MRI-Empty-Default",
      "transform": "translate(-678.000000, -79.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Attribute-Panel"
    }
  }, [_c('g', {
    attrs: {
      "id": "noun_Pencil_1772505",
      "transform": "translate(678.000000, 79.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.3263947,2.50796678 L12.3822923,5.58164035 L4.65818308,13.3318234 L1.62103335,10.2770067 L9.3263947,2.50796678 Z M14.7070242,1.77254795 L13.338432,0.395994754 C12.8134925,-0.131998251 11.951092,-0.131998251 11.4261525,0.395994754 L10.1138039,1.71597727 L13.1697015,4.78965084 L14.6882763,3.2622425 C15.1007288,2.82853396 15.1007288,2.1685427 14.7070242,1.77254795 Z M0.00871929689,14.5763783 C-0.0475242166,14.8215179 0.177449837,15.0478007 0.421171729,14.99123 L3.81453038,14.1615267 L0.796128486,11.10671 L0.00871929689,14.5763783 Z",
      "id": "Shape"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39fa917a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/attributePanel/assets/EditIcon.vue
// module id = 2449
// module chunks = 0